import React from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';

const LookupSubmitButton = ({ loading, children }) => {
  const { t } = useTranslation();

  return (
    <div className={styles['container']}>
      <Button className={styles['button']} htmlType="submit" loading={loading}>
        {children || t('common.lookup')}
      </Button>
    </div>
  );
};

export default LookupSubmitButton;
